import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiBaseballDiamondOutline } from '@mdi/js';
import { FaClipboardList, FaPeopleGroup, FaFutbol } from 'react-icons/fa6';
import { FaSlidersH } from "react-icons/fa";
import axios from 'axios';

function ProfileSidebarLeft() {
  // State to store user data
  const [userData, setUserData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    birthdate: '',
    bio: '',
    profile_picture: '',
    current_team: null,
  });

  useEffect(() => {
    axios.get('/api/users/my-details/')
      .then(response => {
        setUserData(response.data);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });
  }, []);


  return (
    <>
      {/* Advanced filter responsive toggler START */}
      <div className="d-flex align-items-center d-lg-none">
        <button
          className="border-0 bg-transparent"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSideNavbar"
          aria-controls="offcanvasSideNavbar"
        >
          <span className="btn btn-primary">
            <FaSlidersH />
          </span>
          <span className="h6 mb-0 fw-bold d-lg-none ms-2">My profile</span>
        </button>
      </div>
      {/* Advanced filter responsive toggler END */}

      {/* Navbar START */}
      <nav className="navbar navbar-expand-lg mx-0">
        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasSideNavbar">
          {/* Offcanvas header */}
          <div className="offcanvas-header">
            <button
              type="button"
              className="btn-close text-reset ms-auto"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>

          {/* Offcanvas body */}
          <div className="offcanvas-body d-block px-2 px-lg-0">
            {/* Card START */}
            <div className="card overflow-hidden">
              {/* Cover image */}
              <div
                className="h-50px"
                style={
                  userData.current_team?.color
                    ? { backgroundColor: userData.current_team.color }
                    : {
                      backgroundImage: `url(${process.env.PUBLIC_URL}/images/kb_static/Kickball_League_Banner.png)`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                    }
                }
              />

              {/* Card body START */}
              <div className="card-body pt-0">
                <div className="text-center">
                  {/* Avatar */}
                  <div className="avatar avatar-lg mt-n5 mb-3">
                    <a href="#!">
                      <img
                        className="avatar-img rounded border border-white border-3"
                        src={
                          userData.profile_picture ? userData.profile_picture : `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`
                        }
                        alt={`${userData.first_name} ${userData.last_name}`}
                      />
                    </a>
                  </div>
                  {/* Info */}
                  <h5 className="mb-0">
                    <a href="#!">{userData.first_name} {userData.last_name}</a>
                  </h5>
                  <small style={{ color: userData.current_team?.color || 'inherit' }}>
                    {userData.current_team?.name || 'No team'}
                  </small>
                  <p className="mt-3">{userData.bio}</p>

                  {/* User stat START */}
                  <div className="hstack gap-2 gap-xl-3 justify-content-center">
                    {/* User stat item */}
                    <div>
                      <h6 className="mb-0">{userData.current_team?.total_games || '0'}</h6>
                      <small>Games Played</small>
                    </div>
                    {/* Divider */}
                    <div className="vr"></div>
                    {/* User stat item */}
                    <div>
                      <h6 className="mb-0">{userData.current_team?.wins || '0'}</h6>
                      <small>Wins</small>
                    </div>
                    {/* Divider */}
                    <div className="vr"></div>
                    {/* User stat item */}
                    <div>
                      <h6 className="mb-0">{userData.current_team?.losses || '0'}</h6>
                      <small>Loses</small>
                    </div>
                  </div>
                  {/* User stat END */}
                </div>

                {/* Divider */}
                <hr />

                {/* Side Nav START */}
                <ul className="nav nav-link-secondary flex-column fw-bold gap-2">
                  <li className="nav-item">
                    <Link className="nav-link" to="/profile">
                      <FaClipboardList className="me-2" size={16} />
                      <span>Feed</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/teams/user-teams">
                      <FaPeopleGroup className="me-2" size={16} />
                      <span>My Teams</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/leagues/seasons/select">
                      <FaFutbol className="me-2" size={16} />
                      <span> Seasons</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/games/current-season">
                      <Icon path={mdiBaseballDiamondOutline} size={1} />
                      <span> Games</span>
                    </Link>
                  </li>
                </ul>
                {/* Side Nav END */}
              </div>
              {/* Card body END */}
              {/* Card footer */}
              <div className="card-footer text-center py-2">
                <a className="btn btn-link btn-sm" href="/profile/">
                  View Profile
                </a>
              </div>
            </div>
            {/* Card END */}

            {/* Helper link START */}
            {/* <ul className="nav small mt-4 justify-content-center lh-1">
              <li className="nav-item">
                <a className="nav-link" href="my-profile-about.html">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="settings.html">
                  Settings
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_blank" href="https://support.webestica.com/login" rel="noreferrer">
                  Support
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_blank" href="docs/index.html">
                  Docs
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="help.html">
                  Help
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="privacy-and-terms.html">
                  Privacy & terms
                </a>
              </li>
            </ul> */}
            {/* Helper link END */}
            <p className="small text-center mt-1">
              ©2025{' '}
              <a className="text-reset" target="_blank" href="/" rel="noreferrer">
                Kickball League of Chicago
              </a>
            </p>
          </div>
        </div>
      </nav>
      {/* Navbar END */}
    </>
  );
}

export default ProfileSidebarLeft;
